export default function relogin () {
  window.location.href = '/'
}
